import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { useParams, useLocation } from 'react-router-dom'

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

import { SRLWrapper } from "simple-react-lightbox";

import vrfy_gr_middle from '../images/view_gr_middle.png'
import vrfy_doc_gr from '../images/verify_gr.jpg'

import vrfy_gr_mobile from '../images/gr_mobile.png'
import vrfy_gr_desktop from '../images/gr_desktop.png'

import smp_1 from '../images/sample_1.png'
import smp_2 from '../images/sample_2.png'
import smp_4 from '../images/sample_4.png'
import smp_6 from '../images/sample_6.png'

import smp_1_th from '../images/sample_1_thumb.png'
import smp_2_th from '../images/sample_2_thumb.png'
import smp_4_th from '../images/sample_4_thumb.png'
import smp_6_th from '../images/sample_6_thumb.png'




function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));




const Faqs = () =>{
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const Faq = () => {
     
                  
    }
    return(
        <div>

            <div className="vrfy-section page-help page">
            
            <h1>HELP</h1>

            {/*
            <p className="look-for">
                <a href="#view">View Court Document</a> | <a href="#verify">Verify Document</a> | <a href="#sample">Sample Documents</a>
            </p>

            

            <div class="container ">
                <div class="row">
                    <div class="col">
                        <a href="#view">View a Court Document</a>
                    </div>
                    <div class="col">
                        <a href="#verify">Verify Document</a>
                    </div>
                    <div class="col">
                        <a href="#sample">Sample Documents</a>
                    </div>
                </div>
            </div>
            */}


            <div className="vrfy-section how-to">

            <div className="row">
                <div className="col-xs-12" order={2}>

                <h2 className="vrfy-header">How to <strong className="s-l">view</strong> a court document</h2>
                
                <div className="container how-to-wrap">
                    <div className="row">


                    <div className="col-sm">
                        

                        <h4>On your <strong className="s-l">Desktop</strong> or <strong className="s-l">Laptop</strong></h4>
                        <div className="img-desktop"><img src={vrfy_gr_desktop} /></div>
                        <div className="steps-desktop steps">
                            <ol>
                            <li>
                                <h5><strong>Enter URL</strong></h5>
                                <p className="steps-sub">https://evrfy.ttlawcourts.org <span className="st">B</span></p>
                            </li>

                            <li>
                                <h5>Enter the following information:</h5>
                                <ul>
                                <li className="vrfy-arrow">Access Code <span className="st">C</span></li>
                                <li className="vrfy-arrow">Case Number <span className="st">D</span></li>
                                <li className="vrfy-arrow">CAPTCHA Code</li>
                                </ul>
                            </li>


                            <li>
                            <h5>Click <strong>View</strong></h5>
                            </li>

                            </ol>
                        </div>

                    </div>

                    <div className="col-sm middle-column" order={0}>
                        <img className="m-gr" src={vrfy_gr_middle} />
                    </div>

                    <div className="col-sm" order={2}>
                    <h4>On your <strong className="s-l">Mobile phone</strong> or <strong className="s-l">Tablet</strong></h4>
                        <div className="img-desktop"><img src={vrfy_gr_mobile} /></div>
                        <div className="steps-desktop steps">
                            <ol>
                            <li>
                                <h5><strong>Scan the QR Code <span className="st">A</span></strong></h5>
                                <p className="steps-sub">with your device's camera</p>
                            </li>

                            <li>
                                <h5>Enter the following information:</h5>
                                <ul>
                                <li className="vrfy-arrow">Case Number <span className="st">D</span></li>
                                <li className="vrfy-arrow">CAPTCHA Code</li>
                                </ul>
                            </li>

                            <li>
                                <h5>Click <strong>View</strong></h5>
                            </li>

                            </ol>
                        </div>
                    </div>

                    </div>
                </div>
                
                </div>

            </div>

            </div>



            <div className="help-section s-how v-doc">

                <div className="container">
                    <div className="row">
                        <h2>How to verify a court document</h2>

                        <p className="look-for">Please look for the following lettered items when verifying court documents.</p>

                        <div className="col-sm" order={2}>
                            <p>
                                <ul>
                                    <li>Access Code</li>

                                    <li>Case Number</li> 

                                    <li>Registrar’s E-signature and Code</li> 

                                    <li>Judiciary Logo</li> 

                                    <li>E-vrfy Logo</li> 

                                </ul>
                            </p>
                        </div>

                        <div className="col-sm" order={2}>

                            <img className="m-gr" src={vrfy_doc_gr} />


                            
                            
                        </div>

                        <div className="col-sm" order={2}>
                            <p>
                                <ul>
                                    <li>Estates Administration Office Stamp</li>

                                    <li>Court Seal</li> 

                                    <li>High Court Seal Watermark</li> 

                                    <li>Scarlet Ibis Watermark</li> 

                                    <li>B F Document Border</li> 

                                </ul>
                            </p>
                        </div>



                    </div>
                </div>


            </div>


            <div className="help-section s-how v-doc">

            

                <div className="container">
                    <div className="row">
                        <h2>Sample E-Vrfy documents</h2>
                        <p className="look-for">Click to enlarge image</p>

                        <div className="container" order={1}>
                        <SRLWrapper>
                            <div className="row">
                                <div class="col-sm smp-img">
                                    <a href={smp_1}>
                                        <img src={smp_1_th} alt="Grants of probate and letters of administration"/>
                                    </a>
                                    <p className="smp_txt">Grants of probate and letters of administration</p>
                                </div>

                                <div class="col-sm smp-img">
                                    <a href={smp_2}>
                                        <img src={smp_2_th} alt='Electronic Copies (formerly "Office Copies")'/>
                                    </a>
                                    <p className="smp_txt">Electronic Copies (formerly "Office Copies")</p>
                                </div>

                                <div class="col-sm smp-img">
                                    <a href={smp_4}>
                                        <img src={smp_4_th} alt="Electronic Decree Absolute"/>
                                    </a>
                                    <p className="smp_txt">Electronic Decree Absolute</p>
                                </div>

                                <div class="col-sm smp-img">
                                    <a href={smp_6}>
                                        <img src={smp_6_th} alt="Job Letters for Judiciary Officials and Staff"/>
                                    </a>
                                    <p className="smp_txt">Job Letters for Judiciary Officials and Staff</p>
                                </div>
                            </div>
                        </SRLWrapper>
                        </div>
                    </div>
                </div>


            </div>
        

          
        </div>
    </div>
    );




};



export default Faqs;

